import React from 'react';
import gql from 'graphql-tag';
import {GraphQLError} from 'graphql';
import {useMutation} from '@apollo/client';
import Tip from '../../../ui/Tip';
import UILink from '../../../ui/UILink';
import OldUrls from '../../../models/utils/OldUrls';
import {showError, showInfo} from '../../../ui/ToastNotification';


export default function AutomatedEvaluationApproval() {
  const [dismiss] = useMutation(mutation);

  const onDismiss = React.useCallback(() => {
    dismiss({
      variables: {
        id: 'aea-dashboard',
      },
    }).then(
      () => {
        showInfo('Notification dismissed');
      },
      (apolloError) => {
        apolloError.graphQLErrors.map((error: GraphQLError) => showError(error.message));
      },
    );
  }, [dismiss]);

  return (
    <Tip>
      <div className="flex flex-col">
        <div className="pb-3">
          Automate the process of evaluations approval: reduce the amount of manual work,
          and send out certificates to attendees almost immediately.
        </div>
        <div className="flex items-center">
          <UILink href={OldUrls.settings()} className="not-italic">Configure</UILink>
          <UILink href="#" onClick={() => onDismiss()} className="ml-6 not-italic">Dismiss</UILink>
        </div>
      </div>
    </Tip>
  );
}

const mutation = gql`
  mutation DismissNotification($id: ID!) {
    dismissDashboardNotification(id: $id) {
      id
      visible
    }
  }
`;
